import { db } from '../firebase'
import { writeBatch, doc, updateDoc, deleteDoc, getDoc, setDoc } from 'firebase/firestore'
import { auditLogger } from '../services/auditLogger'

export async function updateSingle(
  collection: string,
  id: string,
  data: any,
  userEmail?: string
) {
  await updateDoc(doc(db, collection, id), {
    ...data,
    ...(userEmail ? { updatedBy: userEmail } : {}),
    updatedAt: new Date(),
  })
}

export async function deleteSingle(collection: string, id: string) {
  await deleteDoc(doc(db, collection, id))
}

export async function saveAll(collection: string, updates: { id: string; data: any }[]) {
  const batch = writeBatch(db)
  updates.forEach(u => batch.update(doc(db, collection, u.id), u.data))
  await batch.commit()
}

export async function moveDocToArchive(id: string) {
  const srcRef = doc(db, 'expenses', id)
  const destRef = doc(db, 'expenses_archive', id)
  const snap = await getDoc(srcRef)
  if (!snap.exists()) throw new Error('Entry not found')
  
  const expenseData = snap.data();
  
  // Log the deletion/archival to audit trail
  await auditLogger.logExpenseDelete(
    id,
    expenseData,
    {
      customMetadata: {
        archivedTo: 'expenses_archive',
        deletionType: 'archive',
        originalCollection: 'expenses'
      }
    }
  );
  
  // Move to archive
  await setDoc(destRef, expenseData)
  await deleteDoc(srcRef)
  
}
